import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '../lib/cn'

/**
 * Barra de seleção em lote: substitui o cabeçalho da lista enquanto há linhas marcadas.
 * "3 selecionadas · Reenviar · WhatsApp · Reenviar · e-mail · Baixar .zip · Excluir… · Limpar".
 * Ações em texto; a destrutiva sempre com reticências e confirmação nomeada.
 */
export interface BulkBarProps extends HTMLAttributes<HTMLDivElement> {
  /** "3 assinaturas selecionadas" */
  summary: ReactNode
  actions: ReactNode
  onClear: () => void
  clearLabel?: string
}

export function BulkBar({
  summary,
  actions,
  onClear,
  clearLabel = 'Limpar',
  className,
  ...props
}: BulkBarProps) {
  return (
    <div
      data-slot="bulk-bar"
      role="toolbar"
      aria-label="Ações em lote"
      className={cn(
        'border-ink bg-ink text-pampas flex flex-wrap items-center justify-between gap-x-6 gap-y-3 border px-4 py-3',
        className,
      )}
      {...props}
    >
      <span className="font-display text-[13px] leading-none font-normal">{summary}</span>
      <div className="font-body text-eyebrow flex flex-wrap items-center gap-x-5 gap-y-2 font-light tracking-normal [&>button]:cursor-pointer [&>button]:hover:opacity-80">
        {actions}
        <button type="button" onClick={onClear} className="text-pampas/70">
          {clearLabel}
        </button>
      </div>
    </div>
  )
}
